import { Fragment, useState } from 'react';

import PropTypes from 'prop-types';
import { getFormattedIntNumber } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import Button, { ButtonAppearance, ButtonKind } from 'bloko/blocks/button';
import Conversion from 'bloko/blocks/conversion';
import FormSpacer from 'bloko/blocks/form/FormSpacer';
import InputText, { InputType } from 'bloko/blocks/inputText';
import Modal, { ModalContent, ModalFooter, ModalHeader, ModalTitle } from 'bloko/blocks/modal';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import createGift from 'components/Admin/GiftFormModal/createGift';
import AccountLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/AccountLink';

import { setAccountId, setGiftModalVisible, setUserId } from 'store/models/gift';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/GiftFormModal/GiftFormModal.less';

const GiftFormModal = () => {
    const dispatch = useDispatch();
    const [amount, setAmount] = useState(0);
    const [isLoad, setLoad] = useState(false);
    const { isGiftModalVisible, accountId } = useSelector((state) => state.gift);
    const trl = useTrls();

    const onClickSave = () => {
        dispatch(createGift(setLoad, amount));
    };
    const onClickClose = () => {
        setAmount(0);
        dispatch([setAccountId(0), setUserId(0), setGiftModalVisible(false)]);
    };
    return (
        <Modal visible={isGiftModalVisible} onClose={onClickClose}>
            <ModalHeader>
                <ModalTitle>{trl('Admin.GiftForm.title')}</ModalTitle>
            </ModalHeader>
            <ModalContent>
                <div className="gift-form">
                    <ClickmeFormItem
                        input={<InputText defaultValue={`${accountId}`} type={InputType.Number} disabled />}
                        legend={trl('Admin.GiftForm.Account.legend')}
                        hint={<AccountLink accountId={accountId} text={trl('Admin.GiftForm.Account.hint')} />}
                        isRequired
                    />
                    <ClickmeFormItem
                        input={
                            <InputText
                                value={`${amount}`}
                                onChange={(value) => {
                                    setAmount(parseInt(value, 10));
                                }}
                                type={InputType.Number}
                                placeholder={trl('Admin.GiftForm.Amount.placeholder')}
                                data-qa="bonus-input"
                            />
                        }
                        legend={trl('Admin.GiftForm.Amount.legend')}
                        hint={
                            <Fragment>
                                {getFormattedIntNumber(amount)}
                                {NON_BREAKING_SPACE}
                                <Conversion
                                    zero={trl('Admin.GiftForm.hint.zero')}
                                    one={trl('Admin.GiftForm.hint.one')}
                                    some={trl('Admin.GiftForm.hint.some')}
                                    many={trl('Admin.GiftForm.hint.many')}
                                    value={amount}
                                    hasValue={false}
                                />
                            </Fragment>
                        }
                        isRequired
                    />
                </div>
            </ModalContent>
            <ModalFooter>
                <Button appearance={ButtonAppearance.Outlined} onClick={onClickClose}>
                    {trl('Admin.GiftForm.close')}
                </Button>
                <FormSpacer>
                    <Button
                        kind={ButtonKind.Success}
                        onClick={onClickSave}
                        disabled={isLoad}
                        data-qa="submit-bonus-button"
                    >
                        {trl('Admin.GiftForm.save')}
                    </Button>
                </FormSpacer>
            </ModalFooter>
        </Modal>
    );
};

GiftFormModal.propTypes = {
    isVisible: PropTypes.bool,
    setVisible: PropTypes.func,
};

export default GiftFormModal;
